// prettier-ignore
const orderTabType = {
    orderInfo         : 'orderInfo',
    orderChat         : 'orderChat',
    orderForm         : 'orderForm',
    orderHistory      : 'orderHistory',
};

export default orderTabType;
